export const STORAGE_ERROR = {
  get: (key: string) => `Ошибка при чтении хранилища по ключу ${key}`,
  set: (key: string) => `Ошибка при записи в хранилище по ключу ${key}`,
  remove: (key: string) => `Ошибка при удалении из хранилища по ключу ${key}`,
}

export const STORAGE_KEY = {
  addressSystem: {
    deliveryAddress: 'address-system:delivery-address',
    deliveryWidget: 'address-system:delivery-widget',
  },
}
